/**
 * Sub-folder (under the tenant) that `file_upload` stores an upload in.
 * Anything not listed here keeps the default of `UserProfile`.
 */
export const UPLOAD_FOLDER = {
  USER_PROFILE: 'UserProfile',
  TRAVEL_DOCUMENT: 'travel/documents',
  ACCOMMODATION_DOCUMENT: 'accommodation/documents',
} as const;
